import { optionLabel } from "../../configurazione/adapters";
import React, { useState, useEffect } from 'react';
import apiUrl from '../../../Apiurl';
import axios from "axios";
import stilePulsanti from '../../../interfaccia/stilePulsanti';
import { useAuth0 } from '@auth0/auth0-react';
import InputDatoTendinaGenerico from '../../../modificaProdotti/elementiPagina/InputDatoTendinaGenerico';
import stampaFormatoPSdaIDsped from '../../Stampe/stampaFormatoPSdaIDsped';
import stampaFormatoATTESE from '../../Stampe/stampaFormatoATTESE';
import apriUrl from '../../../interfaccia/funzioniComuni/apriUrl';

function FunzioniStampaPOP({
    setPopUpWindow,
    tema,
    datiTendineOrdine,
    ordiniSelezionati,
    vista
}) {

    const { user, /* isAuthenticated, */ getAccessTokenSilently } = useAuth0();
    const [token, setToken] = useState("");
    const [input, setInput] = useState({
        partenzaDa: false,
    });

    const {
        tastoChiudiAspetto,
        tastoStampaAspetto
    } = stilePulsanti

    useEffect(() => {
        const getUserMetadata = async () => {
            try {
                const accessToken = await getAccessTokenSilently();
                setToken(accessToken);
            } catch (e) {
                console.log(e.message);
            }
        };
        getUserMetadata();
    }, [getAccessTokenSilently, user?.sub]);    

    function chiudi(e) {
        e.preventDefault();
        setPopUpWindow(false);
    }
    const handleChange = async function (evt) {
        const value = evt.target.value;
        try {

            setInput({
                ...input,
                [evt.target.name]: value
            });

        } catch (err) {
            console.log("Errore nell'aggiornamento di un dato non nestato: " + err)
            throw err;
        }
    }

    const exportBRT = async function (mag) {
        if (!token) {
            console.warn("sto aspettando un token")
            return;
        }
        /* if (!input.dataSpediti) {
            alert("Seleziona prima una data");
        } */
        try {

            fetch(apiUrl + "/logistica/csv/exportBRTeasySpedWeb/" + mag, { headers: { Authorization: "Bearer " + token } })
                .then(resp => resp.json())
                .then(data => apriUrl(data))
        } catch (err) {
            console.log("Errore nell'invio degli ordini alle API': " + err)
            throw err;
        }
    }

    function esportaPDFattese() {
        if (!token) {
            console.warn("sto aspettando un token")
            return;
        }
        fetch(apiUrl + "/logistica/pdf/tutteLeAttese", { headers: { Authorization: "Bearer " + token } })
            .then(resp => resp.json())
            .then(data => apriUrl(data))
    }

    const ordiniByIDformatoGLS = async function () {
        if (!token) {
            console.warn("sto aspettando un token")
            return;
        }
        let idOrdini;
        console.log("vista: ",vista,"ordini selezionati: ", ordiniSelezionati);
        try {
            if (vista === "articoli") {
                idOrdini = [...new Set(ordiniSelezionati.map(ord => ord.idSped))]; // Garantisce valori univoci
            } else if (!vista || vista === "ordini") {
                idOrdini = ordiniSelezionati.map(ord => ord.id);
            }
        } catch (err) {
            console.log("Errore nella creazione array ID ordini: " + err)
            throw err;
        }
        console.log(idOrdini);
        try {
            const data = {
                idOrdini: idOrdini
            }
            const config = {
                headers: {
                    'Authorization': 'Bearer ' + token,
                },
            }
            axios.post(apiUrl + "/logistica/pdf/ordiniByIDformatoGLS", data, config)
                .then(data => apriUrl(data.data))
        } catch (err) {
            console.log("Errore nell'invio degli ordini alle API': " + err)
            throw err;
        }
    }


    return (
        <div className='pa2 f6 mw7'>
            <div className='tr'>
                <button className="dim tastoInputOrizzontale br3 br3" onClick={chiudi}>{tastoChiudiAspetto}</button>
            </div>
            
            <div className='pt3 pb3 flex'>
                <div className='ml2 pa4'>
                    <div className='f3 b mb3'>Stampa ordini</div>
                    {ordiniSelezionati?.length>50 && <div className='mb2'>
                        Da questa schermata puoi stampare i fogli degli ordini. Seleziona gli ordini nella schermata principale o fai una ricerca che restituisca <strong>massimo 50 risultati</strong>.
                        Se i risultati sono maggiori o non hai selezionato ordini vedrai qui sotto solo opzioni di stampa generiche (es. tutte le attese, ecc)
                        <br/><br/>TIP: puoi impostare il magazzino di partenza e "da rif PS a rif PS" in ricerca avanzata.
                    </div>}
                    <div className='ml2 pa4 mw6'>
                        <h3 className='mb4'>Genera PDF</h3>
                        
                        {ordiniSelezionati?.length<51 && <div className='flex items-center flex-wrap mb2'>
                            <button className="tastoInputOrizzontale br3 dim w-10 mw3" onClick={() =>stampaFormatoPSdaIDsped(token,ordiniSelezionati,false)}>{tastoStampaAspetto}</button><span className="w-70 pl3">Selezione ordini formato PrestaShop (PDF unico)</span>
                        </div>}
                        {ordiniSelezionati?.length<51 && <div className='flex items-center flex-wrap mb2'>
                            <button className="tastoInputOrizzontale br3 dim w-10 mw3" onClick={ordiniByIDformatoGLS}>{tastoStampaAspetto}</button><span className="w-70 pl3">Selezione ordini formato adesivo (wip)</span>
                        </div>}
                        {ordiniSelezionati?.length<51 && <div className='flex items-center flex-wrap mb2'>
                            <button className="tastoInputOrizzontale br3 dim w-10 mw3" onClick={() =>stampaFormatoATTESE(token,ordiniSelezionati,false, null, vista)}>{tastoStampaAspetto}</button><span className="w-70 pl3">Selezione ordini formato attese</span>
                        </div>}
                        {ordiniSelezionati?.length<1001 && <div className='flex items-center flex-wrap mb2'>
                            <button className="tastoInputOrizzontale br3 dim w-10 mw3" onClick={() =>stampaFormatoATTESE(token,ordiniSelezionati,false, "prelievo", vista)}>{tastoStampaAspetto}</button><span className="w-70 pl3">Selezione ordini lista prelievo (codici raggruppati)</span>
                        </div>}
                        {ordiniSelezionati?.length<1001 && <div className='flex items-center flex-wrap mb2'>
                            <button className="tastoInputOrizzontale br3 dim w-10 mw3" onClick={() =>stampaFormatoATTESE(token,ordiniSelezionati,false, "prelievoDatiCliente", vista)}>{tastoStampaAspetto}</button><span className="w-70 pl3">Selezione ordini lista prelievo (articolo + dati cliente)</span>
                        </div>}
                        {ordiniSelezionati?.length<1001 && <div className='flex items-center flex-wrap mb2'>
                            <button className="tastoInputOrizzontale br3 dim w-10 mw3" onClick={() =>stampaFormatoATTESE(token,ordiniSelezionati,false, "controllo", vista)}>{tastoStampaAspetto}</button><span className="w-70 pl3">Selezione ordini lista controllo</span>
                        </div>}
                        <div className='flex items-center flex-wrap mb2'>
                            <button className="tastoInputOrizzontale br3 dim w-10 mw3" onClick={esportaPDFattese}>{tastoStampaAspetto}</button><span className="w-70 pl3">Tutte le attese</span>
                        </div>
                        {/* <label className='mr1 b' for="dataPartenza">Magazzino partenza: </label>
                        <select
                            name="partenzaDa"
                            id="partenzaDa"
                            onChange={handleChange}
                            value={input.partenzaDa}
                            className="inputOrizzontale mb2"
                        >
                            {datiTendineOrdine.partenzaDa.map((mag, i) => <option key={i + 1} value={mag}>{optionLabel(datiTendineOrdine.partenzaDa, mag)}</option>)}
                        </select>
                        <div className='flex items-center flex-wrap mb2'>
                            <button className="tastoInputOrizzontale br3 dim w-20" onClick={funzionelegataaimagazzini}>{tastoStampaAspetto}</button><span className="w-70">Pick List {input.partenzaDa ? input.partenzaDa : "SELEZIONA MAG"}</span>
                        </div> */}
                    </div>
                </div>
            </div>
        </div>
    )
}


export default FunzioniStampaPOP;
